import React, { useEffect, useState } from 'react';
import { t } from 'Locale';
import { useStore } from 'Store';

import { Text, ScrollView, View, SafeAreaView, SectionList } from 'react-native';
// eslint-disable-next-line import/no-unresolved
import { Background, Button, SectionListHeader } from 'LocalGluons';
import {
    fetchSubcriptionInfo,
    getSubcriptionInfo,
    getAccountInfo,
    onButtonClick
} from './AccountInfoSetting';
import defaultStyles from './AccountInfo.jss';
import AccountInfoListItem from './components/AccountInfoListItem';

import { AccountData, SubscriptionData } from './AccountInfo.types';

const AccountInfo = (): React.ReactElement => {
    const [userSubcriptionData, setUserSubcriptionData] = useState<SubscriptionData | null>(null);
    const [isLoaded, setLoaded] = useState<boolean>(false);

    // useStore() does not has types for userData
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { userData }: { userData: AccountData } = useStore();

    const accountInfoData = getAccountInfo(userData);

    useEffect(() => {
        fetchSubcriptionInfo(setUserSubcriptionData, setLoaded);
    }, []);

    return (
        <Background>
            <ScrollView style={defaultStyles.outerContainer}>
                <SectionList
                    style={defaultStyles.sectionList}
                    sections={accountInfoData}
                    keyExtractor={(item, index) => `${item.text} + ${index}`}
                    renderItem={({ item }) => (
                        <AccountInfoListItem
                            description={item.text}
                            name={item.title}
                            sectionContainer={defaultStyles.sectionText}
                        />
                    )}
                    renderSectionHeader={({ section: { title } }) => (
                        <View style={defaultStyles.sectionHeadercontainer}>
                            <SectionListHeader title={title} />
                        </View>
                    )}
                />
                {isLoaded && !!userSubcriptionData ? (
                    <SafeAreaView>
                        <SectionList<{
                            title: string;
                            description: string | Array<string>;
                        }>
                            style={defaultStyles.sectionList}
                            sections={getSubcriptionInfo(userSubcriptionData)}
                            keyExtractor={(item: { title }, index) => ` ${(item.title, index)}`}
                            renderSectionHeader={({ section: { title } }) => (
                                <View style={defaultStyles.sectionHeadercontainer}>
                                    <SectionListHeader title={title} />
                                </View>
                            )}
                            renderItem={(itemToRender) => (
                                <AccountInfoListItem
                                    name={itemToRender.item.title}
                                    description={itemToRender.item.description}
                                    sectionContainer={defaultStyles.sectionText}
                                />
                            )}
                        />
                        <View style={defaultStyles.textsContainer}>
                            <Text style={defaultStyles.promoText}>
                                {t('SUBSCRIPTION..MANAGE_ACCOUNT_TITLE_MOBILES')}
                            </Text>
                            <View style={defaultStyles.button}>
                                <Button
                                    title={t('COMMON.MANAGE_YOUR_ACCOUNT_BTN_MOBILES')}
                                    onPress={() => onButtonClick()}
                                />
                            </View>
                            <Text style={defaultStyles.greyText}>
                                {t('SUBSCRIPTION.MANAGE_ACCOUNT_BROWSER_INFO_TXT_MOBILES')}
                            </Text>
                        </View>
                    </SafeAreaView>
                ) : null}
            </ScrollView>
        </Background>
    );
};

export default AccountInfo;
